import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <Reveal>
        <SectionHeading
          eyebrow="主题分类"
          title="按领域逛瓜料，更快找到你在意的"
          desc="511爆料把线索按领域归档，投稿时选择对应分类，后台会优先处理匹配的线索。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.map((cat, index) => (
          <Reveal key={cat.id} delay={(index % 3) * 80}>
            <Link
              to={`/square?category=${cat.id}`}
              className="group h-full flex items-start gap-4 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/80 hover:border-accent-400 transition-colors"
            >
              <span className="w-12 h-12 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center shrink-0">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    {cat.count.toLocaleString()} 条
                  </span>
                </span>
                <span className="mt-2 block text-sm text-foreground-600 leading-relaxed">
                  {cat.desc}
                </span>
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}